import * as React from 'react';
import cx from 'classnames';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TravelPolicyTableRows from './TravelPolicyTableRows';
import Loader from 'components/Loader/Loader';
import { TravelPolicyTabTypes } from 'components/UserDetails/UserDetail';

const styles = require('./styles.pcss');

type Props = {
  isLoading: boolean;
  flightPolicy: any;
  product: TravelPolicyTabTypes;
};

const paidSeatsLabel = {
  name: 'Paid Seats',
  description: 'Prevents users from booking paid seats.',
};

const labelMap = {
  enabled: 'Enabled',
  disabled: 'Disabled',
};

class Upgrades extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { flightPolicy = {}, isLoading, product } = this.props;

    return (
      product === TravelPolicyTabTypes.flight && (
        <Paper
          className={
            isLoading ? cx(styles.paper, styles.loading) : styles.paper
          }
        >
          <div className={styles.policyRules}>
            <h2>Restrictions</h2>
            <div>
              <Loader visible={isLoading} />
            </div>
            <Table>
              <TableBody>
                {product === TravelPolicyTabTypes.flight && (
                  <TravelPolicyTableRows
                    key={2}
                    text={paidSeatsLabel}
                    product={product}
                    flight={
                      flightPolicy?.paidSeats
                        ? labelMap.enabled
                        : labelMap.disabled
                    }
                  />
                )}
              </TableBody>
            </Table>
          </div>
        </Paper>
      )
    );
  }
}

export default Upgrades;
